import * as request from '@/utils/request'
import { getLevel } from '@/utils/chat/chatUtil';

let api = '';

// 收藏知识图谱
// params: { kgid: '', level?: 'h'|'m'|'p' }
// ★ level 优先用调用方传入（图谱自带学段），缺省时兜底当前会话学段
export const collectGraph = (params) => request.post(api + '/collectKg', {
    ...params,
    level: params.level || getLevel(),
  });
  
  // 移除收藏
  // params: { kgid: '', level?: 'h'|'m'|'p' }
  // ★ "我的图谱"含多个学段，删除时必须传图谱卡片自带的 level，
  //   否则 getLevel() 传的是当前会话学段，跨学段删除无效
  export const removeGraph = (params) => request.post(api + '/RemoveKg', {
    ...params,
    level: params.level || getLevel(),
  });

// 展示知识图谱名称列表
// return {kgnames: ['不等式-0', '不等式-3']}
export const showGraphNames = () => request.post(api + '/showKgNames', { level: getLevel() })

// 展示知识图谱详情
// params: {kgid: '不等式-0'}
export const showGraph = (params) => request.post(api + '/showKg', params)

// 展示共享知识图谱列表（无须 level，后端按学段全量返回）
// return { h: [kgid, ...], m: [kgid, ...], p: [kgid, ...] }
export const showSharedKgs = () => request.post(api + '/showSharedKgs');